import { graphql } from "@/graphql/codegen"

import "@/entityLock/graphql/entityLock.fragment"
import "@/screens/Accounting/subfeatures/Invoices/graphql/invoice.fragment"

graphql(`
  mutation ChangeInvoiceStatus($input: InvoiceStatusChangeInput!) {
    invoice {
      statusChange(input: $input) {
        __typename
        ... on InvoiceStatusChangeSuccess {
          invoice {
            ...InvoiceBaseFields
          }
        }
        ... on InvoiceStatusChangeFailure {
          error {
            message
          }
        }
        ... on EntityLockFailure {
          error {
            message
            currentLock {
              ...EntityLockBaseFields
            }
          }
        }
      }
    }
  }
`)
